import { placementSelectors } from '../floorplanPlacementsSlice';

/**
 * Get all placement entities
 */
export const selectAllPlacements = (state) =>
  placementSelectors.selectAll(state);

/**
 * Get placements by floorplan ID
 */
export const selectPlacementsByFloorplan = (state, floorplanId) => {
  const all = selectAllPlacements(state);
  return all.filter((placement) => placement.floorplanId === floorplanId);
};

/**
 * Get sensor placements for a floorplan
 */
export const selectSensorPlacementsByFloorplan = (state, floorplanId) => {
  const all = selectAllPlacements(state);
  return all.filter(
    (placement) => placement.floorplanId === floorplanId && placement.deviceId
  );
};

/**
 * Get image placements for a floorplan
 */
export const selectImagePlacementsByFloorplan = (state, floorplanId) => {
  const all = selectAllPlacements(state);
  return all.filter(
    (placement) =>
      placement.floorplanId === floorplanId && placement.filePermissionId
  );
};

/**
 * Get placements by device ID
 */
export const selectPlacementsByDevice = (state, deviceId) => {
  const all = selectAllPlacements(state);
  return all.filter((placement) => placement.deviceId === deviceId);
};

/**
 * Get a specific placement by ID
 */
export const selectPlacementById = (state, placementId) =>
  placementSelectors.selectById(state, placementId);

/**
 * Get placement for a specific device on a specific floorplan
 */
export const selectPlacementForDeviceFloorplan = (
  state,
  deviceId,
  floorplanId
) => {
  const all = selectAllPlacements(state);
  return all.find(
    (placement) =>
      placement.deviceId === deviceId && placement.floorplanId === floorplanId
  );
};

/**
 * Get placements for a specific file (image)
 */
export const selectPlacementsForFile = (state, filePermissionId) => {
  const all = selectAllPlacements(state);
  return all.filter(
    (placement) => placement.filePermissionId === filePermissionId
  );
};

/**
 * Get loading state
 */
export const selectPlacementsLoading = (state) =>
  state.floorplanPlacements.loading;

/**
 * Get error state
 */
export const selectPlacementsError = (state) => state.floorplanPlacements.error;
